<template>
  <div>
    <div class="animals-menu">
      <ul class="navbar-nav">
        <li>
          <a @click="defaultSearch(), searchFlora()">{{ $t('Все') }}</a>
        </li>
      </ul>
    </div>
    <div class="search-head bgw-pdg-20">
      <v-row align-sm="center">
        <v-col cols="12" sm="6" md="3">
          <v-label>{{ $t('Поиск по названию') }}</v-label>
          <v-text-field
            :placeholder="$t('Введите текст')"
            v-model="search.name"
            required
            outlined
            dense
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-label>{{ $t('Национальный статус') }}</v-label>
          <div class="select-def">
            <v-select
              item-value="id"
              item-text="transName"
              :items="data.refNationalStatus"
              v-model="search.nationalStatus"
              :placeholder="$t('Все')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-label>{{ $t('Семейство') }}</v-label>
          <div class="select-def">
            <v-select
              item-value="id"
              item-text="transName"
              :items="data.refFamily"
              v-model="search.family"
              :placeholder="$t('Все')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-checkbox
            v-model="search.inRedBook"
            :label="$t('Красная книга КР')"
          ></v-checkbox>
        </v-col>
      </v-row>
      <div class="search-action">
        <button @click="searchFlora" class="btn btn-default green-grassy">
          {{ $t('Поиск') }}
        </button>
        <router-link
          to="/flora"
          tag="button"
          @click="(search = {})"
          class="btn btn-default gray"
        >
          {{ $t('Очистить') }}
        </router-link>
      </div>
      <div class="hint">
        <p>{{ $t('Всего в базе данных {count} видов растений', { count: data.floraCount }) }}</p>
        <p v-if="totalCount">{{ $t('По вашему запросу найдено') }}: {{ totalCount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Flora from '@/model/flora'
import { mapMutations } from 'vuex'

export default {
  name: 'SearchForm',
  props: {
    retSearch: {
      type: Boolean,
      default: false
    },
    totalCount: Number
  },
  data: () => ({
    search: {},
    data: []
  }),
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      this.search = this.$route.query

      Flora.getFloraData().then((response) => {
        this.data = response.data
        this.setLoading(false)
      })
    },
    searchFlora () {
      if (this.retSearch) {
        return this.$emit('searchFlora', this.search)
      }
      this.setLoading(true)
      this.$router.push({ path: 'flora-class', query: this.search })
    },
    defaultSearch () {
      this.search.name = null
      this.search.family = null
      this.search.nationalStatus = null
      this.search.inRedBook = null
    }
  }
}
</script>
